import { cn } from "utils";

const Header = ({ className, children, ...props }) => {
  return (
    <div
      className={cn("lg:px-6 px-4 pt-4 md:pt-6 flex flex-col gap-6", className)}
      {...props}
    >
      <div className="flex justify-between md:items-center md:gap-6 gap-4 md:flex-row flex-col">
        {children}
      </div>
    </div>
  );
};

const HeaderTitle = ({ className, title, children, ...props }) => {
  return (
    <div className={cn("space-y-1", className)} {...props}>
      <div className="flex gap-2 items-center justify-between md:justify-start">
        <h2 className="text-xl font-semibold">{title}</h2>
        {children}
      </div>
    </div>
  );
};

const HeaderDescription = ({ className, children, ...props }) => {
  return (
    <p className={cn("text-sm text-muted-foreground", className)} {...props}>
      {children}
    </p>
  );
};

const HeaderActions = ({ className, children, ...props }) => {
  return (
    <div
      className={cn("flex gap-3 md:flex-row flex-col-reverse", className)}
      {...props}
    >
      <div className="flex gap-6 justify-end items-center flex-row-reverse md:flex-row">
        {children}
      </div>
    </div>
  );
};

Header.Title = HeaderTitle;
Header.Description = HeaderDescription;
Header.Actions = HeaderActions;

export { Header };
